module.exports = __webpack_public_path__ + "img/Birthregistrationslide.fbe67ed0.jpg";